import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { AppName, CleanMessage } from "../../../util/app";
import "./search.css";
import { useLazyQuery } from "react-apollo";
import { SEARCH_PATIENTS } from "../../../queries/patient.query";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../partials/loading";
import ListView from "../partial/ListView";

const SearchPatients = ({ match, history }) => {
    const { keyword } = match.params;

    const [search, setSearch] = useState(keyword);
    const [docs, setDocs] = useState([]);

    const [searchFunc, { loading }] = useLazyQuery(SEARCH_PATIENTS, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => setDocs(d.SearchPatientAll.docs),
    });

    useEffect(() => {
        if (keyword) searchFunc({ variables: { keyword } });
    }, [keyword, searchFunc]);

    return (
        <>
            <Helmet>
                <title>
                    {search || "Patients search"} | {AppName}
                </title>
            </Helmet>

            <div className="row justify-content-center">
                <div className="col-12 col-md-11 ">
                    {/* <div className="heading">Patient Search</div> */}

                    <form
                        onSubmit={async (event) => {
                            event.preventDefault();
                            await searchFunc({ variables: { keyword: search } });
                        }}
                    >
                        <div className="search-in ci">
                            <i className="material-icons text-primary p-4">search</i>
                            <input
                                defaultValue={search}
                                type="search"
                                placeholder="enter patient name, phone number, occupation, email, or NHS"
                                className="form-control"
                                onChange={({ currentTarget: { value } }) => setSearch(value)}
                            />
                        </div>
                    </form>
                </div>
                <div className="col-12 col-md-11">
                    <div className="card ci">
                        {docs.length > 0 && (
                            <div className="card-head fade-in">
                                <header className="text-primary">Found {docs.length} record(s) </header>
                            </div>
                        )}
                        <div className="card-body search-container">
                            <LoadingSpinner loading={loading} bar={true} />
                            {!loading && docs.length < 1 && (
                                <center>
                                    <div className="heading text-pink">No record found!</div>
                                </center>
                            )}
                            {docs.length > 0 && (
                                <table className="table table-bordered fade-in">
                                    <thead className="fade-in">
                                        <th className="center">SN</th>
                                        <th className="center">Image</th>
                                        <th className="left"> Patient </th>
                                        <th className="center">
                                            <strong>NHS</strong>
                                        </th>
                                        <th className="text-center"> Gender </th>
                                        <th className="center">Birth Date</th>

                                        <th className="text-left">Date of Joining</th>
                                        <th className="text-center">Actions</th>
                                    </thead>

                                    <tbody>
                                        {docs.map((patient, index) => {
                                            return <ListView key={index} history={history} patient={patient} listNo={index + 1} />;
                                        })}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SearchPatients;
